<template>
  <div class="side-cart-container" :class="{ 'is-visible': isVisible }">
    <div class="side-cart-overlay" @click="$emit('close')"></div>
    <div class="side-cart">
      <div class="side-cart-header">
        <h3>您的購物車</h3>
        <button class="close-btn" @click="$emit('close')">&times;</button>
      </div>
      <div class="side-cart-body">
        <div v-if="cartItems.length === 0" class="empty-cart">
          <p>您的購物車是空的。</p>
        </div>
        <div v-else class="cart-items-list">
          <div v-for="item in cartItems" :key="item.id" class="cart-item">
            <img :src="item.image" :alt="item.name" class="item-image" />
            <div class="item-details">
              <p class="item-name">{{ item.name }}</p>
              <p class="item-variant" v-if="item.color || item.size">
                <span v-if="item.color">顏色: {{ item.color }}</span>
                <span v-if="item.color && item.size"> | </span>
                <span v-if="item.size">尺寸: {{ item.size }}</span>
              </p>
              <p class="item-price">{{ item.quantity }} &times; NT$ {{ item.price }}</p>
            </div>
            <button class="remove-btn" @click="removeItem(item.id)">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="side-cart-footer">
        <div class="subtotal">
          <span>小計:</span>
          <span>NT$ {{ subtotal }}</span>
        </div>
        <router-link to="/order/create" class="checkout-btn" @click.native="$emit('close')">
          前往結帳
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'SideCart',
  props: {
    isVisible: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapState(['cartItems']),
    subtotal () {
      return this.cartItems.reduce((total, item) => total + item.price * item.quantity, 0)
    }
  },
  methods: {
    ...mapMutations({
      removeItem: 'removeCartItem' // map this.removeItem() to this.$store.commit('removeCartItem')
    })
  }
}
</script>

<style scoped>
.side-cart-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1001;
  visibility: hidden;
  pointer-events: none;
}
.side-cart-container.is-visible {
  visibility: visible;
  pointer-events: auto;
}
.side-cart-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
}
.side-cart-container.is-visible .side-cart-overlay {
  opacity: 1;
}
.side-cart {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  max-width: 400px;
  height: 100%;
  background-color: var(--pd-black);
  color: var(--pd-white);
  display: flex;
  flex-direction: column;
  box-shadow: -5px 0 15px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  transition: transform 0.3s ease;
}
.side-cart-container.is-visible .side-cart {
  transform: translateX(0);
}
.side-cart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--pd-gray-dark);
}
.side-cart-header h3 {
  margin: 0;
  font-size: 1.2rem;
}
.close-btn {
  background: none;
  border: none;
  color: var(--pd-white);
  font-size: 2rem;
  cursor: pointer;
}
.side-cart-body {
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem;
}
.empty-cart {
  text-align: center;
  margin-top: 5rem;
  color: var(--pd-gray-medium);
}
.cart-items-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.cart-item {
  display: flex;
  gap: 1rem;
  align-items: center;
}
.item-image {
  width: 70px;
  height: 70px;
  object-fit: cover;
  border-radius: 4px;
}
.item-details {
  flex: 1;
}
.item-name {
  margin: 0 0 0.5rem;
  font-weight: 600;
}
.item-variant {
  margin: 0 0 0.5rem;
  font-size: 0.85rem;
  color: var(--pd-gray-medium);
}
.item-price {
  margin: 0;
  color: var(--pd-gray-light);
}
.remove-btn {
  background: none;
  border: none;
  color: var(--pd-gray-medium);
  cursor: pointer;
  font-size: 1rem;
}
.remove-btn:hover {
  color: var(--pd-white);
}
.side-cart-footer {
  padding: 1.5rem;
  border-top: 1px solid var(--pd-gray-dark);
}
.subtotal {
  display: flex;
  justify-content: space-between;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
}
.checkout-btn {
  display: block;
  width: 100%;
  padding: 1rem;
  background-color: var(--pd-white);
  color: var(--pd-black);
  text-align: center;
  text-decoration: none;
  font-weight: 700;
  border-radius: 4px;
  transition: opacity 0.2s ease;
}
.checkout-btn:hover {
  opacity: 0.8;
}

/* Mobile Responsive - Bottom Sheet Style */
@media (max-width: 768px) {
  .side-cart {
    width: 100%;
    max-width: 100%;
    height: 70vh; /* 70% of viewport height instead of full screen */
    top: auto;
    bottom: 0;
    transform: translateY(100%); /* Slide from bottom */
    border-radius: 20px 20px 0 0; /* Rounded top corners */
  }

  .side-cart-container.is-visible .side-cart {
    transform: translateY(0);
  }

  /* Add drag handle indicator */
  .side-cart::before {
    content: '';
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 4px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
  }

  .side-cart-header {
    padding-top: 2rem; /* Extra padding for drag handle */
  }

  .side-cart-header h2 {
    font-size: 1.25rem;
  }

  .cart-item {
    padding: 1rem 0;
  }

  .item-image {
    width: 70px;
    height: 70px;
  }

  .item-details h4 {
    font-size: 0.9375rem;
  }

  .item-price {
    font-size: 0.875rem;
  }

  .side-cart-footer {
    padding: 1.25rem;
  }

  .subtotal {
    font-size: 1rem;
  }

  .checkout-btn {
    padding: 0.875rem;
    font-size: 0.9375rem;
  }
}
</style>
